class ProductParamsTable extends HTMLElement {
    connectedCallback() {
      this.render();
    }
  
    isValidRow(row) {
      if (!row || typeof row !== 'object') return false;
      // The table expects these keys; some datasets include non-row items like { type, content }.
      return (
        'name' in row &&
        'software' in row &&
        'thickness' in row &&
        'quality' in row &&
        'processing' in row &&
        'speed' in row &&
        'max' in row &&
        'mode' in row &&
        'number' in row
      );
    }

    isTitleRow(row) {
      return row && typeof row === 'object' && row.type === 'title';
    }

    cell(value) {
      // Avoid rendering literal "undefined" in table cells.
      if (value === undefined || value === null || value === '') return '-';
      return value;
    }

    render() {
      const handle = this.dataset.handle;
      if (!handle || typeof jsonData === 'undefined') return;
  
      const dataKey = this.findDataKey(handle);
      if (!dataKey || !jsonData[dataKey] || !jsonData[dataKey].length) return;
  
      const headers = jsonData.table_header;
      // Keep material rows AND title separators; drop anything else.
      const rows = jsonData[dataKey].filter((r) => this.isValidRow(r) || this.isTitleRow(r));
      if (!rows.some((r) => this.isValidRow(r))) return;
      const grouped = this.groupByMaterial(rows);
      this.columnCount = headers.length;
  
      this.innerHTML = `
        <div class="params-table__wrapper">
          <h3 class="params-table__title">Model Parameters</h3>
          <div class="params-table__scroll">
            <table class="params-table">
              <thead>
                <tr>
                  ${headers.map((h) => `<th>${h}</th>`).join('')}
                </tr>
              </thead>
              <tbody>
                ${this.renderGroupedRows(grouped)}
              </tbody>
            </table>
          </div>
        </div>
      `;
    }
  
    findDataKey(handle) {
      const normalized = handle.replace(/[-_]/g, '').toLowerCase();
      for (const key in jsonData) {
        if (key === 'table_header') continue;
        if (key.toLowerCase() === normalized) return key;
      }
      // Try removing common prefixes
      const withoutPrefix = normalized.replace(/^atomstack/, '');
      for (const key in jsonData) {
        if (key === 'table_header') continue;
        if (key.toLowerCase() === withoutPrefix) return key;
      }
      // Partial match: check if handle contains the key or vice versa
      for (const key in jsonData) {
        if (key === 'table_header') continue;
        const keyNorm = key.toLowerCase();
        if (normalized.includes(keyNorm) || keyNorm.includes(normalized)) return key;
      }
      return null;
    }
  
    groupByMaterial(rows) {
      const groups = [];
      let current = null;
      for (const row of rows) {
        if (this.isTitleRow(row)) {
          // A title separator breaks the current group and renders full-width.
          groups.push({ title: row.content || '' });
          current = null;
          continue;
        }
        if (!current || current.name !== row.name) {
          current = { name: row.name, rows: [row] };
          groups.push(current);
        } else {
          current.rows.push(row);
        }
      }
      return groups;
    }

    renderGroupedRows(groups) {
      let html = '';
      for (const group of groups) {
        if (group.title !== undefined) {
          html += `<tr class="params-table__section"><td class="params-table__section-cell" colspan="${this.columnCount}">${group.title}</td></tr>`;
          continue;
        }
        group.rows.forEach((row, i) => {
          html += '<tr>';
          if (i === 0) {
            html += `<td class="params-table__material" rowspan="${group.rows.length}">${this.cell(group.name)}</td>`;
          }
          html += `<td>${this.cell(row.software)}</td>`;
          html += `<td>${this.cell(row.thickness)}</td>`;
          html += `<td>${this.cell(row.quality)}</td>`;
          html += `<td>${this.cell(row.processing)}</td>`;
          html += `<td>${this.cell(row.speed)}</td>`;
          html += `<td>${this.cell(row.max)}</td>`;
          html += `<td>${this.cell(row.mode)}</td>`;
          html += `<td>${this.cell(row.number)}</td>`;
          html += '</tr>';
        });
      }
      return html;
    }
  }
  
  if (!customElements.get('product-params-table')) {
    customElements.define('product-params-table', ProductParamsTable);
  }
  